import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";

export default function useUsernamePrefix() {
  const { get } = useApiHelper();

  // The company prefix every added user's username starts with, e.g. "gp" for "gp-apile"
  const usernamePrefix = useQuery({
    queryKey: ["usernamePrefix"],
    queryFn: () => get<DefaultResponseWithData<string | null>>("/customer/users/prefix"),
    staleTime: 1000 * 60 * 30,
  });

  return {
    usernamePrefix,
  };
}
